import { render, staticRenderFns } from "./PhilosophyPage.vue?vue&type=template&id=17392e37&scoped=true"
import script from "./PhilosophyPage.vue?vue&type=script&lang=js"
export * from "./PhilosophyPage.vue?vue&type=script&lang=js"
import style0 from "./PhilosophyPage.vue?vue&type=style&index=0&id=17392e37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17392e37",
  null
  
)

export default component.exports